import React, {Component} from 'react';

import ReactHighcharts from 'react-highcharts';
import './styles.scss';
import Comment from '../../../common/comment';

export default class ColumnChart extends Component {


    _getGraphConfig = () => {
        return {
            chart: {
                    type: 'column',
                    height:300,

                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: this.props.months
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Volumen (m3)'
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            color: 'gray'
                        },
                        formatter: function () {
                                            return `<b>${ReactHighcharts.Highcharts.numberFormat(this.total,0)}</b>`
                                        }
                    }
                },
                legend: {
                    align: 'right',
                    verticalAlign: 'top',
                    layout: 'horizontal',
                    x: 0,
                    y: 0,
                    padding: 8,
                    itemMarginBottom: 15,
                    itemStyle: {
                         lineHeight: '35px',
                         fontSize: 13,
                         fontWeight:500,
                         color:'#585858',
                    },
                    floating: false,
                    backgroundColor: 'white',
                    shadow: false
                },
                tooltip: {
                    pointFormat: '<b>{point.y:.0f}</b>'
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        pointWidth: 40,



                    }
                },
                credits:{
                    enabled:false
                },
                series: this.props.data
        };
    }



    render() {

        let graph_config = this._getGraphConfig();
        let style=this.props.value===5? {width:'%99', marginLeft:5}: {width:'%98', marginLeft:30}

        return (
            <div>
                <ReactHighcharts config={graph_config}/>
                <div className={"chart-data"} style={style}>
                    <div className="slp">SLP</div>
                    {this.props.percentages.map((value, index)=>{
                        return(
                        <Comment key={index}>
                            <div className={"percentage"}>{value.m3===0?0:value.percentage} %</div>
                        </Comment>);
                    })}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/slpPerFuel/components/columnChart/ColumnChart.js